import { ChangeDetectorRef, Component, contentChild, contentChildren } from '@angular/core';
import { EtlIngestionService } from '../../services/etl-ingestion/etl-ingestion.service';
import { AppService } from '../../app.service';
import { catchError, finalize, firstValueFrom, tap } from 'rxjs';
import { OffersConfigService } from '../../services/offers-config/offers-config.service';
import { isArrayWithData } from '../../utilities/array.helpers';
import { ModalDialogSeverity } from '../../enums/modal-dialog-severity';

@Component({
    selector: 'offers-config',
    templateUrl: './offers-config.component.html',
    styleUrl: './offers-config.component.css',
})
export class OffersConfigComponent {
    isListOfferSideBarVisible: boolean = false;
    isOffersTypeView: boolean = false;
    offersViewData: any;
    offerTypeViewHeading: string | undefined = '';
    offerTypeViewTtitle: string = '';
    editedId: string | number = '';
    selectedCreditorId: string = '';
    creditorCompanyName: string = '';
    formSelectedCreditorId: string = '';
    formCreditorCompanyName: string = '';
    offersConfigs!: any[];
    filteredOffersConfigs: any[] = []; // filtered data
    filterOffersStatus: number = 1;
    hasClickedSearch: boolean = false;
    getListOffersRes: any = {};

    transactionTypeList: any[] = [];
    frequencyList: any[] = [];
    offerTransactionType: any;
    offerFrequency: any;
    offerInstallment: any;
    offerDays: string = '';
    offerOrderNo: number = 1;
    editIsSIF: boolean = false;

    isRecurringTypeSelected: string = '';
    paymentType: string = 'PayNow';
    frequencyValues: any[] = [
        {name: 'Weekly', value: 7},
        {name: 'Fortnightly', value: 14},
        {name: 'Semi-Monthly', value: 15},
        {name: 'Monthly', value: 30 },
    ]

    public constructor(
        private etlIngestionService: EtlIngestionService,
        public appService: AppService,
        private offersConfigService: OffersConfigService,
        private cdr: ChangeDetectorRef
    ) { }
    public offersStatusOptions = [
        {
            id: 0,
            label: 'No',
        },
        {
            id: 1,
            label: 'Yes',
        },
    ];
    public offersTypeOptions = [
        {
            id: 1,
            label: 'Balance',
        },
        {
            id: 2,
            label: 'Duration',
        },
    ];
    public offersTypeMeta: any = {
        1: {
            label: 'Balance',
            title: 'Balance offers may apply to outstanding amount'
        },
        2: {
            label: 'Duration',
            title: 'Duration offers may apply to outstanding amount within a specified range of days'
        }
    };

    ngOnInit() {
        this.getOffersTableData(this.filterOffersStatus);
        this.getTransactionTypeList();
    }

    get hasTableData(): boolean {
        return isArrayWithData(this.offersConfigs);
    }

    getOffersTypeLabel(id: number): string | undefined {
        return this.offersTypeOptions.find(option => option.id === id)?.label;
    }

    getTransactionTypeLabel(id: number): string | undefined {
        return this.transactionTypeList.find(obj => obj.Id === id)?.TransactionType;
    }

    getSettlementTypeText(offers: any): string {
        const label = this.getOffersTypeLabel(offers.SettlementTypeId) ?? '';
        if (label && offers.IsSettlementPaymentEnabled !== 1) {
            return `${label} (Disabled)`;
        }
        return label;
    }

    getFrequencyByTransectionType(data: any): string {
        const transactionType = this.getTransactionTypeLabel(data.TransectionType);
        if (transactionType === 'AdHocPayment') {
            return data.Frequency === 4 ? 'Schedule Payment' : 'Pay Now';    
        }
        return this.getFrequencyLabel(data.Frequency) ?? '';
    }

    getFrequencyLabel(id: number): string | undefined {
        return this.frequencyList.find(obj => obj.Frequency === id)?.PaymentFrequency;
    }

    extractId(value: string | null | undefined): string {
        if (!value) return '';
        return value.split('/').pop() || '';
    }

    getTransactionTypeList(){
        this.appService.isShowPageSpinner = true;
        this.offersConfigService.getTransactionType()
            .pipe(
                tap((res: any) => {                   
                    if (res.result) {
                        this.transactionTypeList = res.result.filter(
                        (obj: any) =>
                            obj.TransactionType === 'AdHocPayment' ||
                            obj.TransactionType === 'RecurringPayment'
                        );
                    }
                }),
                catchError(this.appService.handleError),
                finalize(() => {
                    this.appService.isShowPageSpinner = false;
                })
            )
            .subscribe();
    }

    getFrequencyList(creditorId: string){
        this.appService.isShowPageSpinner = true;
        this.offersConfigService.getFrequencyListByCreditor(creditorId)
            .pipe(
                tap((res: any) => {                   
                    if (res.result) {
                        this.frequencyList = res.result.filter(
                        (obj: any) =>
                            obj.PaymentFrequency != 'Custom'
                        );
                    }
                }),
                catchError(this.appService.handleError),
                finalize(() => {
                    this.appService.isShowPageSpinner = false;
                })
            )
            .subscribe();
    }

    getOffersTableData(has_offers: number) {
        const HasOffers = has_offers === 1 ? true : false;
        this.appService.isShowPageSpinner = true;
        this.offersConfigs = [];
        this.offersConfigService.getOffers(HasOffers)
            .pipe(
                tap((res: any) => {
                    if (!!res) {
                        this.offersConfigs = res.result;
                        this.filteredOffersConfigs = [...this.offersConfigs];
                    }
                }),
                catchError(this.appService.handleError),
                finalize(() => {
                    this.appService.isShowPageSpinner = false;
                })
            )
            .subscribe();
    }
    
    async getListoffers(creditorId: string) {
        this.appService.isShowPageSpinner = true;
        try {
            const res: any = await firstValueFrom(
                this.offersConfigService.getListOffersByCreditor(creditorId)
            );
            this.getListOffersRes = Array.isArray(res?.result)
                ? res.result
                : [];
        } catch (error) {
            this.appService.handleError;
        } finally{
            this.appService.isShowPageSpinner = false;
        }
    }


    onSelectCreditor(event: any) {
        this.selectedCreditorId = event.CreditorId;
        this.creditorCompanyName = event.CompanyName;
        this.search()
    }

    search() {
        this.filteredOffersConfigs = this.offersConfigs.filter(item => {
            const matchCreditor = !this.creditorCompanyName || item.CompanyName === this.creditorCompanyName;
            return matchCreditor;
        });
    }

    onOpenListOfferSideBar(formSelectedCreditorId?: string,
        formCreditorCompanyName?: string, data?: {
            id?: string;
            transectionType?: number;
            frequency?: number;
            noOfInstallment?: number;
            offerOrderNo?: number;
            isSif?: boolean;
        }){
        this.formCreditorCompanyName = formCreditorCompanyName || '';
        this.formSelectedCreditorId = formSelectedCreditorId || '';

        if(data){
            // Edit Mode
            this.editedId = data?.id || '';
            this.offerTransactionType = data?.transectionType;
            this.offerFrequency = data?.frequency;
            this.offerInstallment = data?.noOfInstallment;
            this.offerOrderNo = data?.offerOrderNo || 0;
            this.editIsSIF = data?.isSif || false;
            this.onChangeTransactionType();
            this.checkOfferDays();
            if (this.isRecurringTypeSelected == 'AdHocPayment') {
                 this.paymentType = data.frequency === 4 ? 'SchedulePayment' : 'PayNow';    
            }
        }else{
            // Add Mode (reset data)
            this.editedId = '';
            this.offerTransactionType = '';
            this.offerFrequency = '';
            this.offerInstallment = null;
            this.offerDays = '';
            this.offerOrderNo = this.getListOffersRes.length;
            this.editIsSIF = this.offersViewData.IsSettlementPaymentEnabled === 1 ? true : false; 
            this.isRecurringTypeSelected = '';
        }

        this.isListOfferSideBarVisible = true;
    }

    onCloseOfferTypeView() {
        this.isOffersTypeView = false;
        this.getListOffersRes = {};
    }

    async onOpenOfferTypeView(item: any) {
        const meta = this.offersTypeMeta[item.SettlementTypeId];
        this.appService.isShowPageSpinner = true;
        this.offersViewData = item;
        this.offerTypeViewHeading = meta?.label;
        this.offerTypeViewTtitle = meta?.title;
        this.getFrequencyList(this.extractId(item.CreditorId));
        await this.getListoffers(this.extractId(item.CreditorId));
        this.isOffersTypeView = true;
    }

    checkOfferDays(){
        const selectedFrequencyName = this.frequencyList.find(
            (item: any) => item.Frequency === this.offerFrequency
        );

        const selectedFrequencyValue = this.frequencyValues.find(
            (item: any) => item.name === selectedFrequencyName.PaymentFrequency
        );
        const installment = this.offerInstallment

        if (selectedFrequencyValue) {
            let totalDays = 0;
            if(installment > 1){
                totalDays = (selectedFrequencyValue?.value * (installment - 1)) + this.offersViewData.PaymentPlansPlusDayLimit;                   
            }else{
                totalDays = selectedFrequencyValue?.value;
            }
            this.offerDays = `${totalDays} ${totalDays > 1 ? 'Days' : 'Day'}`;
        }

    }

    getNumberOfDays(frequency: any, installment: number){
        const selectedFrequencyValue = this.frequencyValues.find(
            (item: any) => item.name == frequency
        );

        let totalDays = 0;
        if(installment > 1){
            totalDays = (selectedFrequencyValue?.value * (installment - 1)) + this.offersViewData.PaymentPlansPlusDayLimit;                
        }else{
            totalDays = selectedFrequencyValue?.value;
        }
        return `${totalDays} ${totalDays > 1 ? 'Days' : 'Day'}`;
    }

    onChangeTransactionType(){
        const type  = this.transactionTypeList.find((obj)=> obj.Id === this.offerTransactionType).TransactionType;
        this.isRecurringTypeSelected = type;
        if(this.isRecurringTypeSelected == 'AdHocPayment'){
            this.offerFrequency = 0;
            this.offerInstallment = null;
        }
    }

    onSave() {     
        if(!this.offerOrderNo){
            this.appService.showCommonMessageDialog(
                'Validation',
                'Please enter order number.'
            );
            return;
        }

        if(this.isRecurringTypeSelected == 'RecurringPayment' && !this.offerInstallment){
            this.appService.showCommonMessageDialog(
                'Validation',
                'Please enter number of installment.'
            );
            return;
        }

        if(this.isRecurringTypeSelected == 'AdHocPayment' && this.paymentType != 'PayNow'){
            this.offerFrequency = 4;
        }
        
        let payload: any = {
            CreditorId: Number(this.extractId(this.offersViewData.CreditorId)),
            TransectionType: this.offerTransactionType,
            Frequency: this.offerFrequency,
            OrderNo: this.offerOrderNo,
            NoOfInstallment: this.offerInstallment || 0,
            IsSIF: this.editIsSIF ? 1 : 0,
            IsActive: 1,
        }
        this.appService.isShowPageSpinner = true;
        
        if(this.editedId){// update

            payload["OfferId"] = Number(this.editedId);
            payload["UpdatedOnUtc"] = new Date();
            payload["UpdatedBy"] = "";

            this.offersConfigService.updateOffersOffer(payload)
            .pipe(
                tap(async (res: any) => {                    
                    if (res.Status) {
                        this.appService.showCommonMessageDialog(
                            'Success',
                            'Offer has been successfully updated.'
                        );
                        await this.getListoffers(this.extractId(this.offersViewData.CreditorId));
                    } else {
                        this.appService.showCommonMessageDialog(
                            'Error',
                            res.Message || 'Failed to update offers offer. Please try again.'
                        );
                    }
                }),
                catchError(this.appService.handleError),
                finalize(() => {
                    this.appService.isShowPageSpinner = false;
                    this.isListOfferSideBarVisible = false;
                })
            )
            .subscribe();
        }else{// create
            payload["CreatedOnUtc"] = new Date();
            payload["CreatedBy"] = "";
            
            this.offersConfigService.createOffersOffer(payload)       
            .pipe(
                tap(async (res: any) => {                    
                    if (res.Status) {
                        this.appService.showCommonMessageDialog(
                            'Success',
                            'Offer has been successfully created.'
                        );
                        await this.getListoffers(this.extractId(this.offersViewData.CreditorId));
                    }else {
                        
                        this.appService.showCommonMessageDialog(
                            'Error',
                            res.Message || 'Failed to create offers offer. Please try again.'
                        );
                    }
                }),
                catchError(this.appService.handleError),
                finalize(() => {
                    this.appService.isShowPageSpinner = false;
                    this.isListOfferSideBarVisible = false;
                })
            )
            .subscribe();

        }
    }

    onOfferDelete(id: number){
        this.appService.ShowModalDialog(ModalDialogSeverity.Warning, "Confirm Deletion", 'Are you sure you want to delete this offer?', 'OK', 'CANCEL')
        .subscribe((response) => {            
            if (response === 'OK') {
                this.appService.isShowPageSpinner = true;
                    this.offersConfigService.deleteOffersById(id)
                    .pipe(
                        tap(async (res: any) => {
                            if (res.Status) {
                                await this.getListoffers(this.extractId(this.offersViewData.CreditorId));
                                this.appService.showCommonMessageDialog(
                                    'Success',
                                    'Offer has been successfully deleted.'
                                );
                            }
                        }),
                        catchError(this.appService.handleError),
                        finalize(() => {
                            this.appService.isShowPageSpinner = false;
                        })
                    )
                    .subscribe();
            }
        });
    }

    onOfferStatusChange(id: number, event: boolean) {
        const status: number = event ? 1 : 0;        
        this.appService.isShowPageSpinner = true;
        this.offersConfigService.updateOffersOfferStatus(id, status)
        .pipe(
            tap(async (res: any) => {
                if (res.Status) {
                    this.appService.isShowPageSpinner = false;
                    await this.getListoffers(this.extractId(this.offersViewData.CreditorId));
                }
            }),
            catchError(this.appService.handleError),
            finalize(() => {
                this.appService.isShowPageSpinner = false;
            })
        )
        .subscribe();
    }  
    
    onCreditorStatusChange(id: any, event: boolean) {        
        const status: number = event ? 1 : 0;        
        this.appService.isShowPageSpinner = true;
        this.offersConfigService.updateCreditorOfferStatus(Number(this.extractId(id)), status)
        .pipe(
            tap(async (res: any) => {
                if (res.Status) {
                    this.appService.isShowPageSpinner = false;
                    this.getOffersTableData(this.filterOffersStatus);
                }
            }),
            catchError(this.appService.handleError),
            finalize(() => {
                this.appService.isShowPageSpinner = false;
            })
        )
        .subscribe();
    }  
}
